export default __webpack_public_path__ + "static/media/Download.9d54caf2.svg";